import { render, staticRenderFns } from "./line1.vue?vue&type=template&id=0bc0cbca&scoped=true&"
import script from "./line1.vue?vue&type=script&lang=js&"
export * from "./line1.vue?vue&type=script&lang=js&"
import style0 from "./line1.vue?vue&type=style&index=0&id=0bc0cbca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0cbca",
  null
  
)

export default component.exports